import React from 'react';
import {Button, Col} from 'react-bootstrap';

const ApplyFiltersButton = (props) => (
  <Col md={4} style={{textAlign: 'right'}}>
    <Button onClick={props.applyFilters} style={{marginLeft: 'auto', marginTop:'10px'}}>
      Apply Filters
    </Button>
  </Col>
)
export default ApplyFiltersButton;
